import React, { useEffect, useContext, useMemo, useReducer } from 'react';

import { Button, Tab, Tabs, Typography } from '@mui/material';
import { CommonDataContext } from '../firebase/CommonDataContext';
import { FirebaseNewContext } from '../firebase/FirebaseNewContext';
import { GlobalSettingsContext } from '../firebase/GlobalSettingsContext';
import { UserDataContext } from '../firebase/UserDataContext';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { DataGrid, GridToolbar, useGridApiRef } from '@mui/x-data-grid';
import { TeamDropdown } from '../components/forms/Dropdowns/TeamDropdown';
import { EventDropdown } from '../components/forms/Dropdowns/EventDropdown';
import CategoryDropdown from '../components/forms/Dropdowns/CategoryDropdown';
import DivisionDropdown from '../components/forms/Dropdowns/DivisionDropdown';
import { avgByCategoryInEvent, avgByDivisionInEvent, avgOverallInEvent, getCategoryTopOverallInEvent, getEventCategoryPlaceInEvent, getFinalScoresByTeam, getOverallTopInEvent, getPlacementOverallInEvent, groupedEventsScores, getPlacementOverAllEventsAndCategories } from '../components/misc/Utils';

const resultsPageInitialState = (_) => {
    return {
        eventsScores: {},
        teamsDetails: {},
        byTeam: '',
        byEvent: '',
        byCategory: '',
        byDivision: '',
        byHighestCategory: '',
        byHighestEvent: ''
    }

}
const resultsPageReducer = (state, action) => {
    switch (action.type) {
        case 'values_changed':
            return {
                ...state,
                ...action.value
            }
        case 'by_team_changed':
            return {
                ...state,
                byTeam: action.value || ''
            }
        case 'by_event_changed':
            return {
                ...state,
                byEvent: action.value || ''
            }
        case 'by_category_changed':
            return {
                ...state,
                byCategory: action.value || ''
            }
        case 'by_division_changed':
            return {
                ...state,
                byDivision: action.value || ''
            }
        case 'by_highest_category_changed':
            return {
                ...state,
                byHighestCategory: action.value || ''
            }
        case 'by_highest_event_changed':
            return {
                ...state,
                byHighestEvent: action.value || ''
            }
        case 'affiliated_changed':
            return {
                ...state,
                average_affiliated: action.value || ''
            }
        default:
            break
    }
}

function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Grid2 sx={{ p: 3 }}>
                    {children}
                </Grid2>
            )}
        </div>
    );
}
function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

const overallStandingsColumns = [
    { field: 'col1', headerName: 'Team Number ', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 150 },
    { field: 'col4', headerName: 'Division', width: 150 },
    { field: 'col5', headerName: 'Final Score', width: 150, getApplyQuickFilterFn: () => null },
    { field: 'col6', headerName: 'Final Score Non Affiliated', width: 150, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Place', width: 150, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Place Non Affiliated', width: 150, getApplyQuickFilterFn: () => null },
]
const byTeamColumns = [
    { field: 'col1', headerName: 'Event Number', width: 125 },
    { field: 'col2', headerName: 'Event Name', width: 250 },
    { field: 'col3', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col4', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col5', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col6', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Category Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Overall Place', width: 125, getApplyQuickFilterFn: () => null }
]
const byEventColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 150 },
    { field: 'col4', headerName: 'Division', width: 150 },
    { field: 'col5', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col6', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Final Score Non Affiliated', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col12', headerName: 'Place Non Affiliated', width: 125, getApplyQuickFilterFn: () => null }
]
const byCategoryColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 150 },
    { field: 'col4', headerName: 'Division', width: 150 },
    { field: 'col5', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
]
const byDivisionColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 150 },
    { field: 'col4', headerName: 'Division', width: 150 },
    { field: 'col5', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
]
const byHighestPlacingByCategoryColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 225 },
    { field: 'col3', headerName: 'Category', width: 125 },
    { field: 'col4', headerName: 'Overall Category Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col5', headerName: 'Overall Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col6', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Affiliated Category Category Place', width: 125, getApplyQuickFilterFn: () => null }
]

const byOverallWinnersColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 125 },
    { field: 'col4', headerName: 'Event Number', width: 125 },
    { field: 'col5', headerName: 'Event Name', width: 225 },
    { field: 'col6', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
]
const byOverallSchoolWinnersColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 125 },
    { field: 'col4', headerName: 'Event Number', width: 125 },
    { field: 'col5', headerName: 'Event Name', width: 225 },
    { field: 'col6', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
]
const byTopSixForEachEventColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 125 },
    { field: 'col4', headerName: 'Event Number', width: 125 },
    { field: 'col5', headerName: 'Event Name', width: 225 },
    { field: 'col6', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col12', headerName: 'Associated Place', width: 125, getApplyQuickFilterFn: () => null },
]
const byMissingScoresColumns = [
    { field: 'col1', headerName: 'Event Number', width: 125 },
    { field: 'col2', headerName: 'Event Name', width: 250 },
    { field: 'col3', headerName: 'Team Number', width: 125 },
    { field: 'col4', headerName: 'Team Name', width: 225 },
]

const by1500Columns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 125 },
    { field: 'col4', headerName: 'Event Number', width: 125 },
    { field: 'col5', headerName: 'Event Name', width: 225 },
    { field: 'col6', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
]
const byEventCategoryColumns = [
    { field: 'col1', headerName: 'Team Number', width: 125 },
    { field: 'col2', headerName: 'Team Name', width: 250 },
    { field: 'col3', headerName: 'Category', width: 150 },
    { field: 'col4', headerName: 'Division', width: 150 },
    { field: 'col5', headerName: 'Final Score', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col6', headerName: 'Category Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col7', headerName: 'Overall Avg', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col8', headerName: 'Category Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col9', headerName: 'Overall Top', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col10', headerName: 'Place', width: 125, getApplyQuickFilterFn: () => null },
    { field: 'col11', headerName: 'Initial Place', width: 125, getApplyQuickFilterFn: () => null }
]
const ResultsPage = (props) => {
    const [state, dispatch] = useReducer(resultsPageReducer, props, resultsPageInitialState)
    const [value, setValue] = React.useState(0);
    const handleChange = (_, newValue) => {
        setValue(newValue);
    };
    const apiRef = useGridApiRef();

    const { globalSettings } = useContext(GlobalSettingsContext)
    const { user, defaultSelectedCompetition } = useContext(UserDataContext)

    const { firebase } = useContext(FirebaseNewContext)
    const { teamsMap: globalTeamsMap, eventsMap: globalEventsMap } = useContext(CommonDataContext)
    const teamsMap = useMemo(() => {
        return globalTeamsMap[defaultSelectedCompetition]
    })
    const eventsMap = useMemo(() => {
        // TODO - exclude the events which should be excluded
        return globalEventsMap[defaultSelectedCompetition]
    })
    const categoriesMap = useMemo(() => {
        if (Object.keys(globalSettings).length != 0) {
            return globalSettings['categories'][defaultSelectedCompetition]
        }
        return {}
    }, [globalSettings])
    const divisionsMap = useMemo(() => {
        if (Object.keys(globalSettings).length != 0) {
            return globalSettings['divisions'][defaultSelectedCompetition]
        }
        return {}
    }, [globalSettings])

    useEffect(() => {
        const fetch = async () => {
            if (defaultSelectedCompetition !== '' && Object.keys(teamsMap).length != 0) {
                const scoresMapResult = await firebase.getScores(defaultSelectedCompetition)
                // NOTE  - our dupe finder
                //const dupeFinder = Object.keys(scoresMapResult).reduce((acc,v) => {
                //    const myScore  = scoresMapResult[v]
                //    if (! acc[myScore.team.teamNumber] ) {
                //        acc[myScore.team.teamNumber] = { }
                //    }

                //    if (! acc[myScore.team.teamNumber][myScore.event.number]) {
                //            acc[myScore.team.teamNumber][myScore.event.number] = {
                //                total: 0,
                //                scoreId: []
                //            }
                //    }
                //    //console.log(myScore, v)
                //    //console.log('before we crash', acc)
                //    acc[myScore.team.teamNumber][myScore.event.number]['total'] = acc[myScore.team.teamNumber][myScore.event.number]['total'] + 1
                //    acc[myScore.team.teamNumber][myScore.event.number]['scoreId'].push(v)

                //    return acc
                //}, {})
                //const foundDupes = Object.keys(dupeFinder).reduce((acc, v) => {
                //    const team = dupeFinder[v]
                //    const inner = Object.keys(team).reduce((innerAcc, w) => {
                //        const event = team[w]
                //        console.log(event)
                //        if (event.total > 1) {
                //            console.log('we have a dupe', event)
                //        }


                //    }, {})
                //    return acc
                //}, {})
                //console.log(dupeFinder)
                // TEAM

                getFinalScoresByTeam(scoresMapResult, teamsMap, eventsMap)
                let eventScoresMap = groupedEventsScores(scoresMapResult, eventsMap, teamsMap)
                // EVENT
                avgByCategoryInEvent(eventScoresMap, categoriesMap)
                avgByDivisionInEvent(eventScoresMap, divisionsMap)
                avgOverallInEvent(eventScoresMap)

                getOverallTopInEvent(eventScoresMap)
                getCategoryTopOverallInEvent(eventScoresMap, categoriesMap)
                getEventCategoryPlaceInEvent(eventScoresMap, categoriesMap)
                getPlacementOverallInEvent(eventScoresMap)

                getPlacementOverAllEventsAndCategories(eventScoresMap, teamsMap, categoriesMap)

                // TEAM
                dispatch({
                    type: 'values_changed',
                    value: {
                        eventsScores: eventScoresMap,
                        teamsDetails: teamsMap
                    }
                })

                console.log(eventScoresMap);
            }
        }
        fetch().catch(console.error)

    }, [])

    const overallRows = useMemo(() => {
        return Object.keys(state.teamsDetails).map((t) => {
            const team = state.teamsDetails[t]
            return {
                id: t,
                col1: team.teamNumber,
                col2: team.teamName,
                col3: categoriesMap[team.category],
                col4: divisionsMap[team.division],
                col5: team.finalScore,
                col6: team.finalScoreAssociated,
                col7: team.place,
                col8: team.placeAssociated
            }
        })
    }, [state.teamsDetails, categoriesMap, divisionsMap])

    const overallStandings = (value, index) => {
        if (value !== index) return false
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={overallRows}
                    columns={overallStandingsColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }
    const byTeam = (value, index, teamUid) => {
        // TODO - this throws an error if you attempt to select a team when no scores
        //  for the competition have been entered in
        if (value !== index) {
            return false
        }
        if (teamUid == '') {
            return (<Typography>No Team Selected</Typography>)
        }

        let rows = Object.keys(state.eventsScores).map((e) => {
            const event = state.eventsScores[e]
            const targetScore = event.scores.find(x => x.teamUid == teamUid)
            if (!targetScore) {
                return false
            }
            return {
                id: event.event.number,
                col1: event.event.number,
                col2: `${event.event.name}${event.event.company ? ' - ' + event.event.company : ''}`,
                col3: targetScore.finalScore,
                col4: event.categoriesAvg[targetScore.team.category],
                col5: event.avgOverall,
                col6: event.categoryTop[targetScore.team.category],
                col7: event.overallTopInEvent,
                col8: targetScore.categoryPlace,
                col9: targetScore.overallPlace

            }
        })

        rows = rows.filter(x => x != false)
        //if (rows.filter(x => x != false).length !== Object.keys(state.eventsScores).length) {
        //    return (
        //        <Typography>All scores for the team have not been entered</Typography>
        //    )
        //}
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <Typography>Team Number: {state.teamsDetails[teamUid]['teamNumber']}</Typography>
                <Typography>Category: {categoriesMap[state.teamsDetails[teamUid]['category']]}</Typography>
                <Typography>Division: {divisionsMap[state.teamsDetails[teamUid]['division']]}</Typography>
                <Typography>Overall Place: {state.teamsDetails[teamUid]['place']}</Typography>
                <Typography>Category Place: {state.teamsDetails[teamUid]['categoryPlace']}</Typography>
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows}
                    columns={byTeamColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }
    const byEventRows = useMemo(() => {
        const event = state.eventsScores[state.byEvent]
        if (!event || !Array.isArray(event.scores)) return []
        return event.scores.map((s, idx) => ({
            id: `${state.byEvent || s.eventUid || ''}-${s.teamUid || ''}-${idx}`,
            col1: s.team.teamNumber,
            col2: s.team.teamName,
            col3: categoriesMap[s.team.category] || '',
            col4: divisionsMap[s.team.division] || '',
            col5: s.finalScore,
            col6: event.categoriesAvg?.[s.team.category] ?? '',
            col7: event.avgOverall ?? '',
            col8: event.categoryTop?.[s.team.category] ?? '',
            col9: event.overallTopInEvent ?? '',
            col10: s.overallPlace,
            col11: s.finalScoreAssociated,
            col12: s.overallPlaceAssociated,
        }))
    }, [state.byEvent, state.eventsScores, categoriesMap, divisionsMap])

    const byEvent = (value, index, eventUid) => {
        if (value !== index) {
            return false
        }
        if (!eventUid) {
            return (<Typography>No Event Selected</Typography>)
        }
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={byEventRows}
                    columns={byEventColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }

    // Additional memoized heavy builders
    const winnersRows = useMemo(() => {
        const out = [];
        Object.keys(state.eventsScores || {}).forEach((e) => {
            const event = state.eventsScores[e];
            if (!event || !Array.isArray(event.scores)) return;
            const winner = event.scores.find(s => s.overallPlace === 1);
            if (winner) {
                out.push({
                    id: `${e}-${winner.teamUid}`,
                    col1: winner.team.teamNumber,
                    col2: winner.team.teamName,
                    col3: categoriesMap[winner.team.category] || '',
                    col4: winner.event?.number || event.event?.number || '',
                    col5: `${winner.event?.name || event.event?.name || ''} ${winner.event?.company || event.event?.company || ''}`,
                    col6: winner.finalScore,
                    col7: event.categoriesAvg?.[winner.team.category] ?? '',
                    col8: event.avgOverall ?? '',
                    col9: event.categoryTop?.[winner.team.category] ?? '',
                    col10: event.overallTopInEvent ?? '',
                    col11: winner.overallPlace
                })
            }
        })
        return out;
    }, [state.eventsScores, categoriesMap])

    const nonAffiliatedWinners = useMemo(() => {
        const out = [];
        const affiliatedEventsToTeams = Object.keys(eventsMap || {}).reduce((acc, v) => {
            const event = eventsMap[v] || {};
            if (event.associatedTeams) acc[v] = (event.associatedTeams || []).map(a => a.uid);
            return acc;
        }, {});
        Object.keys(state.eventsScores || {}).forEach((e) => {
            const event = state.eventsScores[e];
            if (!event || !Array.isArray(event.scores)) return;
            const nonAff = event.scores.filter(s => !(affiliatedEventsToTeams[e] || []).includes(s.teamUid)).sort((a,b) => a.finalScore - b.finalScore);
            if (nonAff.length>0) {
                const s = nonAff[0];
                out.push({
                    id: `${e}-${s.teamUid}`,
                    col1: s.team.teamNumber,
                    col2: s.team.teamName,
                    col3: categoriesMap[s.team.category] || '',
                    col4: s.event?.number || event.event?.number || '',
                    col5: `${s.event?.name || event.event?.name || ''} ${s.event?.company || event.event?.company || ''}`,
                    col6: s.finalScore,
                    col7: event.categoriesAvg?.[s.team.category] ?? '',
                    col8: event.avgOverall ?? '',
                    col9: event.categoryTop?.[s.team.category] ?? '',
                    col10: event.overallTopInEvent ?? '',
                    col11: s.overallPlace
                })
            }
        })
        return out;
    }, [state.eventsScores, eventsMap, categoriesMap])

    const schoolWinners = useMemo(() => {
        const out = [];
        Object.keys(state.eventsScores || {}).forEach((e) => {
            const event = state.eventsScores[e];
            if (!event || !Array.isArray(event.scores)) return;
            const school = event.scores.filter(s => (categoriesMap[s.team.category]||'') === 'School').sort((a,b)=>a.finalScore-b.finalScore);
            if (school.length>0) {
                const s = school[0];
                out.push({
                    id: `${e}-${s.teamUid}`,
                    col1: s.team.teamNumber,
                    col2: s.team.teamName,
                    col3: categoriesMap[s.team.category] || '',
                    col4: s.event?.number || event.event?.number || '',
                    col5: `${s.event?.name || event.event?.name || ''} ${s.event?.company || event.event?.company || ''}`,
                    col6: s.finalScore,
                    col7: event.categoriesAvg?.[s.team.category] ?? '',
                    col8: event.avgOverall ?? '',
                    col9: event.categoryTop?.[s.team.category] ?? '',
                    col10: event.overallTopInEvent ?? '',
                    col11: s.overallPlace
                })
            }
        })
        return out;
    }, [state.eventsScores, categoriesMap]);

    const topSixRows = useMemo(() => {
        const rows = [];
        const assoc = [];
        Object.keys(state.eventsScores || {}).forEach(e => {
            const event = state.eventsScores[e];
            if (!event || !Array.isArray(event.scores)) return;
            event.scores.forEach(s => {
                if ([1,2,3,4,5,6].includes(s.overallPlace)) rows.push({ id: `${e}-${s.teamUid}`, col1: s.team.teamNumber, col2: s.team.teamName, col3: categoriesMap[s.team.category]||'', col4: s.event?.number||event.event?.number||'', col5: `${s.event?.name||event.event?.name||''} ${s.event?.company||event.event?.company||''}`, col6: s.finalScore, col7: event.categoriesAvg?.[s.team.category]??'', col8: event.avgOverall??'', col9: event.categoryTop?.[s.team.category]??'', col10: event.overallTopInEvent??'', col11: s.overallPlace, col12: s.overallPlaceAssociated });
                if ([1,2,3,4,5,6].includes(s.overallPlaceAssociated)) assoc.push({ id: `${e}-${s.teamUid}`, col1: s.team.teamNumber, col2: s.team.teamName, col3: categoriesMap[s.team.category]||'', col4: s.event?.number||event.event?.number||'', col5: `${s.event?.name||event.event?.name||''} ${s.event?.company||event.event?.company||''}`, col6: s.finalScore, col7: event.categoriesAvg?.[s.team.category]??'', col8: event.avgOverall??'', col9: event.categoryTop?.[s.team.category]??'', col10: event.overallTopInEvent??'', col11: s.overallPlace, col12: s.overallPlaceAssociated });
            })
        })
        return { rows, assoc };
    }, [state.eventsScores, categoriesMap]);

    const by1500Rows = useMemo(() => {
        const out = [];
        Object.keys(state.eventsScores || {}).forEach(e => { const event = state.eventsScores[e]; if (!event || !Array.isArray(event.scores)) return; event.scores.filter(x => x.finalScore==1500).forEach(s=> out.push({ id: `${e}-${s.teamUid}`, col1: s.team.teamNumber, col2: s.team.teamName, col3: categoriesMap[s.team.category]||'', col4: s.event?.number||event.event?.number||'', col5: `${s.event?.name||event.event?.name||''} ${s.event?.company||event.event?.company||''}`, col6: s.finalScore, col7: event.categoriesAvg?.[s.team.category]??'', col8: event.avgOverall??'', col9: event.categoryTop?.[s.team.category]??'', col10: event.overallTopInEvent??'', col11: s.overallPlace })); }); return out; }, [state.eventsScores, categoriesMap]);

    const highestInCategoryMap = useMemo(() => {
        const map = {};
        Object.keys(state.eventsScores || {}).forEach(evUid => {
            const event = state.eventsScores[evUid]; if (!event || !Array.isArray(event.scores)) return; const byCategory = {}; event.scores.forEach(s => { const cat = s.team.category; if (!byCategory[cat]) byCategory[cat]=[]; byCategory[cat].push(s); }); Object.keys(byCategory).forEach(cat=>{ const arr = byCategory[cat].sort((a,b)=>a.overallPlace-b.overallPlace); map[evUid] = map[evUid]||{}; map[evUid][cat] = arr.map((s, idx) => ({ id: `${evUid}-${s.teamUid}`, col1: s.team.teamNumber, col2: s.team.teamName, col3: categoriesMap[s.team.category]||'', col4: divisionsMap[s.team.division]||'', col5: s.finalScore, col6: event.categoriesAvg?.[s.team.category]??'', col7: event.avgOverall??'', col8: event.categoryTop?.[s.team.category]??'', col9: event.overallTopInEvent??'', col10: idx+1, col11: s.overallPlace })) }); }); return map; }, [state.eventsScores, categoriesMap, divisionsMap]);

    // end new memos

    const byCategory = (value, index, categoryUid) => {
        if (value !== index) {
            return false
        }
        if (categoryUid == '') {
            return (<Typography>No Category Selected</Typography>)
        }
        const rows = Object.keys(state.teamsDetails).reduce((accTeam, t) => {
            const team = state.teamsDetails[t]
            if (team.category !== categoryUid) {
                return accTeam
            }
            accTeam = accTeam.concat({
                id: t,
                col1: team.teamNumber,
                col2: team.teamName,
                col3: categoriesMap[team.category],
                col4: divisionsMap[team.division],
                col5: team.finalScore

            })
            return accTeam
        }, [])

        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows}
                    columns={byCategoryColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }
    const byDivision = (value, index, divisionUid) => {
        if (value !== index) {
            return false
        }
        if (divisionUid == '') {
            return (<Typography>No Division Selected</Typography>)
        }

        const rows = Object.keys(state.teamsDetails).reduce((accTeam, t) => {
            const team = state.teamsDetails[t]
            if (team.division !== divisionUid) {
                return accTeam
            }
            accTeam = accTeam.concat({
                id: t,
                col1: team.teamNumber,
                col2: team.teamName,
                col3: categoriesMap[team.category],
                col4: divisionsMap[team.division],
                col5: team.finalScore

            })
            return accTeam
        }, [])

        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows}
                    columns={byDivisionColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }
    const byHighestPlacingByCategory = (value, index) => {
        if (value !== index) {
            return false
        }
        const rows = Object.keys(state.teamsDetails).reduce((acc, t) => {
            const team = state.teamsDetails[t]

            if ([1, 2, 3, 4, 5, 6].includes(team.categoryPlace)) {
                acc = acc.concat({
                    id: t,
                    col1: team.teamNumber,
                    col2: team.teamName,
                    col3: categoriesMap[team.category],
                    col4: team.categoryPlace,
                    col5: team.place,
                    col6: team.finalScore,
                    col7: team.categoryPlaceAssociated
                })
            }

            return acc
        }, [])
        const rowsAffiliated = Object.keys(state.teamsDetails).reduce((acc, t) => {
            const team = state.teamsDetails[t]

            if ([1, 2, 3, 4, 5, 6].includes(team.categoryPlaceAssociated)) {
                acc = acc.concat({
                    id: t,
                    col1: team.teamNumber,
                    col2: team.teamName,
                    col3: categoriesMap[team.category],
                    col4: team.categoryPlace,
                    col5: team.place,
                    col6: team.finalScore,
                    col7: team.categoryPlaceAssociated
                })
            }

            return acc
        }, [])
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={state.average_affiliated ? rowsAffiliated : rows}
                    columns={byHighestPlacingByCategoryColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }
    const byOverallWinners = (value, index) => {
        if (value !== index) {
            return false
        }
        const rows = winnersRows
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows.filter(x => Object.keys(x).length != 0)}
                    columns={byOverallWinnersColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }
    const byOverallWinnersNonAffiliated = (value, index) => {
        if (value !== index) {
            return false
        }
        // use memoized non‑affiliated winners
        const rows = nonAffiliatedWinners
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows.filter(x => Object.keys(x).length != 0)}
                    columns={byOverallWinnersColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }
    const byOverallSchoolWinners = (value, index) => {

        if (value !== index) {
            return false
        }
        const rows = Object.keys(state.eventsScores).map((e, k) => {
            const event = state.eventsScores[e]
            const scores = event.scores
            const schoolScores = scores.reduce((acc, s) => {
                if (categoriesMap[s.team.category] == 'School') {
                    acc = acc.concat(s)
                }
                return acc
            }, [])
            const schoolScoresSorted = [...schoolScores].sort((a, b) => {
                return a.finalScore - b.finalScore
            })
            return schoolScoresSorted.reduce((acc, s, index) => {
                if (index === 0) {
                    const theId = `${e}-${s.teamUid}`
                    acc = {
                        id: theId,
                        col1: s.team.teamNumber,
                        col2: s.team.teamName,
                        col3: categoriesMap[s.team.category],
                        col4: s.event.number,
                        col5: `${s.event.name}${s.event.company ? ' - ' + s.event.company : ''}`,
                        col6: s.finalScore,
                        col7: event.categoriesAvg[s.team.category],
                        col8: event.avgOverall,
                        col9: event.categoryTop[s.team.category],
                        col10: event.overallTopInEvent,
                        col11: s.overallPlace
                    }
                }

                return acc
            }, {})

        })
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows.filter(x => Object.keys(x).length != 0)}
                    columns={byOverallSchoolWinnersColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }
    const byTopSixForEachEvent = (value, index) => {

        if (value !== index) {
            return false
        }
        // use memoized top-six rows
        const { rows, assoc } = topSixRows;

        const handleCustomPrint = (associated) => {
            const allRows = associated ? assoc : rows;
            console.log(allRows);

            const grouped = allRows.reduce((acc, row) => {
                if (!acc[row.col4]) {
                    acc[row.col4] = {
                        eventName: row.col5,
                        rows: []
                    };
                }
                acc[row.col4].rows.push(row);
                return acc;
            }, {});

            const sortedEvents = Object.keys(grouped).sort((a, b) => Number(a) - Number(b));

            // Buold html
            const printableContent = sortedEvents.map(eventNumber => {
                console.log(grouped[eventNumber]);
                const { eventName, rows: eventRows } = grouped[eventNumber];

                const rowsHtml = eventRows
                .sort((a, b) => Number(associated ? a.col12 : a.col11) - Number(associated ? b.col12 : b.col11))
                .map(row => `
                    <tr>
                    <td>${row.col1}</td>
                    <td>${row.col2}</td>
                    <td>${row.col3}</td>
                    <td>${row.col6}</td>
                    <td>${row.col7}</td>
                    <td>${row.col8}</td>
                    <td>${row.col9}</td>
                    <td>${row.col10}</td>
                    <td>${row.col11}</td>
                    <td>${row.col12}</td>
                    </tr>
                    `)
                .join('');

                return `
                    <div style="page-break-after: always;">
                    <h2>Event: ${eventNumber} - ${eventName} </h2>
                    <table border="1" cellspacing="0" cellpadding="5">
                    <thead>
                    <tr><th>Team Number</th><th>Team Name</th><th>Category</th><th>Final Score</th><th>Category Avg</th><th>Overall Avg</th><th>Category Top</th><th>Overall Top</th><th>Place</th><th>Associated Place</th></tr>
                    </thead>
                    <tbody>${rowsHtml}</tbody>
                    </table>
                    </div>
                    `;
            }).join('');

            const html = `
                <html>
                <head>
                <title>${globalSettings.competitions[defaultSelectedCompetition]}</title>
                </head>
                <body>
                ${printableContent}
                <script>
                window.onload = function() {
                window.print();
                window.close();
                }
                </script>
                </body>
                </html>
                `;

            const printWindow = window.open('', '_blank');
            printWindow.document.write(html);
            printWindow.document.close();
        };

        const CustomToolbar = () => (
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '12px 16px',
                borderBottom: '1px solid #e0e0e0'
            }}>
                <GridToolbar />

                <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    

                    <Button
                        variant="outlined"
                        onClick={() => handleCustomPrint(state.average_affiliated)}
                    >
                        Custom Print
                    </Button>
                </div>
            </div>
        );

        return (
            <Grid2 style={{ height: '700px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={state.average_affiliated ? assoc : rows}
                    columns={byTopSixForEachEventColumns}
                    slots={{ toolbar: CustomToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }
    
    const missingRows = useMemo(() => {
        const allTeamUids = Object.keys(teamsMap || {})
        return Object.keys(state.eventsScores || {}).reduce((acc, e) => {
            const event = state.eventsScores[e]
            if (!event) return acc
            const teamScoreUids = (event.scores || []).map(x => x.teamUid)
            const missingTeams = allTeamUids.filter(x => teamScoreUids.indexOf(x) === -1)
            missingTeams.forEach((teamUid) => {
                acc = acc.concat({
                    id: `${e}-${teamUid}`,
                    col1: event.event.number,
                    col2: `${event.event.name}${event.event.company ? ' - ' + event.event.company : ''}`,
                    col3: teamsMap[teamUid]?.teamNumber || '',
                    col4: teamsMap[teamUid]?.teamName || ''
                })
            })
            return acc
        }, [])
    }, [teamsMap, state.eventsScores])

    const byMissingScores = (value, index) => {
        if (value !== index) return false
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={missingRows}
                    columns={byMissingScoresColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }

    const by1500 = (value, index) => {
        if (value !== index) {
            return false
        }
        const rows = Object.keys(state.eventsScores).reduce((acc, e) => {
            const event = state.eventsScores[e]
            const scores = event.scores
            const biiigScores = scores.filter(x => x.finalScore == 1500)

            if (biiigScores.length != 0) {
                biiigScores.forEach((s) => {
                    acc = acc.concat({
                        id: `${s.teamUid}${s.eventUid}`,
                        col1: s.team.teamNumber,
                        col2: s.team.teamName,
                        col3: categoriesMap[s.team.category],
                        col4: s.event.number,
                        col5: `${s.event.name}${s.event.company ? ' - ' + s.event.company : ''}`,
                        col6: s.finalScore,
                        col7: event.categoriesAvg[s.team.category],
                        col8: event.avgOverall,
                        col9: event.categoryTop[s.team.category],
                        col10: event.overallTopInEvent,
                        col11: s.overallPlace
                    })
                })
            }
            return acc

        }, [])
        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows.filter(x => Object.keys(x).length != 0)}
                    columns={by1500Columns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )
    }

    const byHighestInCategory = (value, index, eventUid, categoryUid) => {
        if (value !== index) {
            return false
        }

        if (eventUid == '') {
            return (<Typography>No Event Selected</Typography>)
        }

        if (categoryUid == '') {
            return (<Typography>No Category Selected</Typography>)
        }

        const event = state.eventsScores[eventUid]
        
        let currentPlace = 0;
        let previousOverallPlace = null;

        const rows = !event ? [] : event.scores
            .filter((s) => s.team.category === categoryUid)
            .sort((a, b) => a.overallPlace - b.overallPlace)
            .map((s, index) => {
                if (previousOverallPlace !== s.overallPlace) {
                    previousOverallPlace = s.overallPlace;
                    currentPlace++;
                }

                return {
                    id: `${eventUid}-${s.teamUid}`,
                    col1: s.team.teamNumber,
                    col2: s.team.teamName,
                    col3: categoriesMap[s.team.category],
                    col4: divisionsMap[s.team.division],
                    col5: s.finalScore,
                    col6: event.categoriesAvg[s.team.category],
                    col7: event.avgOverall,
                    col8: event.categoryTop[s.team.category],
                    col9: event.overallTopInEvent,
                    col10: currentPlace,
                    col11: s.overallPlace
                };
            });



        return (
            <Grid2 style={{ height: '500px', width: '100%' }} >
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={rows}
                    columns={byEventCategoryColumns}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        )

    }

    const byOverallEventScores = (value, index) => {
        if (value !== index) {
            return false
        }

        const eventRows = Object.keys(state.eventsScores).map((eventUid) => {
            const event = state.eventsScores[eventUid];
            return {
                id: eventUid,
                col1: `${event.event.number} - ${event.event.name}${event.event.company ? ' - ' + event.event.company : ''}`,
                col2: event.avgOverall, // The average overall score for the event
            };
        });

        console.log(state.eventsScores);

        return (
            <Grid2 style={{ height: '500px', width: '100%' }}>
                <DataGrid
                    sx={{ marginBottom: '25px' }}
                    rows={eventRows}
                    columns={[
                        { field: 'col1', headerName: 'Event Name', flex: 1 },
                        { field: 'col2', headerName: 'Average Score', flex: 1 },
                    ]}
                    slots={{ toolbar: GridToolbar }}
                    slotProps={{
                        toolbar: {
                            showQuickFilter: true,
                            quickFilterProps: { debounceMs: 500 },
                        },
                    }}
                />
            </Grid2>
        );
    };

    return (
        <Grid2>
            <Grid2 sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <Tabs
                    value={value}
                    onChange={handleChange}
                    variant="scrollable"
                    scrollButtons
                    allowScrollButtonsMobile
                >
                    <Tab label="Overall Standings" {...a11yProps(0)} />
                    <Tab label="By Teams" {...a11yProps(1)} />
                    <Tab label="By Events" {...a11yProps(2)} />
                    <Tab label="By Categories" {...a11yProps(3)} />
                    <Tab label="By Divisions" {...a11yProps(4)} />
                    <Tab label="Highest Placing Category" {...a11yProps(5)} />
                    <Tab label="Overall Winners" {...a11yProps(6)} />
                    <Tab label="Overall Winners Non Affiliated" {...a11yProps(7)} />
                    <Tab label="Overall School Winners" {...a11yProps(8)} />
                    <Tab label="Top 6 For Each Event" {...a11yProps(9)} />
                    <Tab label="Missing Scores" {...a11yProps(10)} />
                    <Tab label="Scores With 1500" {...a11yProps(11)} />
                    <Tab label="Highest in Category" {...a11yProps(12)} />
                    <Tab label="Overall Event Scores" {...a11yProps(13)} />
                </Tabs>
            </Grid2>
<label style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '14px' }}>
                        <input
                            type="checkbox"
                            checked={state.average_affiliated}
                            onChange={() =>
                                dispatch({
                                    type: "affiliated_changed",
                                    value: !state.average_affiliated
                                })
                            }
                        />
                        Show Affiliated
                    </label>
            <TabPanel value={value} index={0}>
                {overallStandings(value, 0)}
            </TabPanel>
            <TabPanel value={value} index={1}>
                <TeamDropdown
                    teamsMapValues={teamsMap}
                    value={state.byTeam}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_team_changed',
                            value: selected.uid
                        })
                    }}
                />
                {byTeam(value, 1, state.byTeam)}
            </TabPanel>
            <TabPanel value={value} index={2}>
                <EventDropdown
                    eventsMapValues={eventsMap}
                    value={state.byEvent}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_event_changed',
                            value: selected.uid
                        })
                    }}
                />
                {byEvent(value, 2, state.byEvent)}
            </TabPanel>
            <TabPanel value={value} index={3}>
                <CategoryDropdown
                    categoriesMapValues={categoriesMap}
                    value={state.byCategory}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_category_changed',
                            value: selected
                        })
                    }}
                />
                {byCategory(value, 3, state.byCategory)}
            </TabPanel>
            <TabPanel value={value} index={4}>
                <DivisionDropdown
                    divisionsMapValues={divisionsMap}
                    value={state.byDivision}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_division_changed',
                            value: selected
                        })
                    }}
                />
                {byDivision(value, 4, state.byDivision)}
            </TabPanel>
            <TabPanel value={value} index={5}>
                {byHighestPlacingByCategory(value, 5)}
            </TabPanel>
            <TabPanel value={value} index={6}>
                {byOverallWinners(value, 6)}
            </TabPanel>
            <TabPanel value={value} index={7}>
                {byOverallWinnersNonAffiliated(value, 7)}
            </TabPanel>
            <TabPanel value={value} index={8}>
                {byOverallSchoolWinners(value, 8)}
            </TabPanel>
            <TabPanel value={value} index={9}>
                {byTopSixForEachEvent(value, 9)}
            </TabPanel>
            <TabPanel value={value} index={10}>
                {byMissingScores(value, 10)}
            </TabPanel>
            <TabPanel value={value} index={11}>
                {by1500(value, 11)}
            </TabPanel>
            <TabPanel value={value} index={12}>
                <EventDropdown
                    eventsMapValues={eventsMap}
                    value={state.byHighestEvent}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_highest_event_changed',
                            value: selected.uid
                        })
                    }}
                />
                <CategoryDropdown
                    categoriesMapValues={categoriesMap}
                    value={state.byHighestCategory}
                    onChange={(e, selected) => {
                        e.preventDefault()
                        dispatch({
                            type: 'by_highest_category_changed',
                            value: selected
                        })
                    }}
                />
                {byHighestInCategory(value, 12, state.byHighestEvent, state.byHighestCategory)}
            </TabPanel>
            <TabPanel value={value} index={13}>
                {byOverallEventScores(value, 13)}
            </TabPanel>
        </Grid2>
    )
}

export default ResultsPage
